import { createSelector } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import { getPersistedItem, setPersistedItem } from '~/hooks/usePersistedStorage'

const name = 'active'

export const slice = createSlice({
  name,
  initialState: getPersistedItem('active') ?? {},
  reducers: {
    setActive(state, { payload: { key, id } }) {
      state[key] = id
      setPersistedItem('active', state)
    },
  },
})

export const { setActive } = slice.actions

export const active = createSelector(
  [(state) => state, (state, key) => key],
  (state, key) => state[name][key]
)
